/**
 * 本地记录评论点赞 / 信息流互动选中态，下次进入页面可恢复
 */

const COMMENT_VOTE_PREFIX = 'timeline/commentVote/';
const INTERACTION_PREFIX = 'timeline/interaction/';

const safeParse = (raw, fallback) => {
    try {
        return raw ? JSON.parse(raw) : fallback;
    } catch (e) {
        return fallback;
    }
};

const safeSet = (key, value) => {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
        console.error(e);
    }
};

/**
 * @returns {{ voted: boolean, liked: boolean } | null}
 */
export const getCommentVote = commentId => {
    if (!commentId) {
        return null;
    }

    return safeParse(localStorage.getItem(`${COMMENT_VOTE_PREFIX}${commentId}`), null);
};

/**
 * @param {string} commentId
 * @param {{ voted: boolean, liked: boolean }} state
 */
export const setCommentVote = (commentId, { voted, liked }) => {
    if (!commentId) {
        return;
    }

    safeSet(`${COMMENT_VOTE_PREFIX}${commentId}`, {
        voted: !!voted,
        liked: !!liked,
    });
};

/**
 * @returns {Record<string, { voted: boolean, checked: boolean }>}
 */
export const getInteractionVotes = articleId => {
    if (!articleId) {
        return {};
    }

    return safeParse(localStorage.getItem(`${INTERACTION_PREFIX}${articleId}`), {}) || {};
};

/**
 * 按当前列表状态整表写入某篇文章的互动记录
 * @param {string} articleId
 * @param {Array<{ key: string, checked: boolean }>} list
 * @param {Record<string, boolean>} votedMap
 */
export const saveInteractionVotes = (articleId, list = [], votedMap = {}) => {
    if (!articleId) {
        return;
    }

    const prev = getInteractionVotes(articleId);
    const next = { ...prev };

    list.forEach(item => {
        next[item.key] = {
            voted: !!(votedMap[item.key] || prev[item.key]?.voted),
            checked: !!item.checked,
        };
    });

    safeSet(`${INTERACTION_PREFIX}${articleId}`, next);
};
